import React from 'react';
import PropTypes from 'prop-types';

import { Button } from '@metarouter-private/mr-mui';

export default function UpdatePlaybooksButton({ onShowBulkPlaybookUpdate }) {
  return (
    <Button variant="outlined" onClick={onShowBulkPlaybookUpdate} data-test-id="bulkStageButton">
      Add or Update Integrations
    </Button>
  );
}

UpdatePlaybooksButton.propTypes = {
  onShowBulkPlaybookUpdate: PropTypes.func.isRequired,
};
